/**
 * Navegação do módulo Cadastros.
 */

export const DRAWER_WIDTH = 280;
export const DRAWER_WIDTH_COLLAPSED = 72;

export const NAV_ITEMS = [
  {
    path: "/modulo/cadastros/produtos/consulta",
    label: "Localizar Produtos",
    shortLabel: "Localizar",
    icon: "Search",
  },
  {
    path: "/modulo/cadastros/dashboard",
    label: "Dashboard",
    shortLabel: "Dashboard",
    icon: "Dashboard",
  },
  {
    path: "/modulo/cadastros/produtos",
    label: "Solicitações",
    shortLabel: "Solicitações",
    icon: "Inventory",
  },
  {
    path: "/modulo/cadastros/produtos/nova",
    label: "Nova solicitação",
    shortLabel: "Nova",
    icon: "Add",
  },
  {
    path: "/modulo/cadastros/produtos/estoque",
    label: "Aguardando Estoque",
    shortLabel: "Estoque",
    icon: "Warehouse",
  },
  {
    path: "/modulo/cadastros/produtos/master",
    label: "Aguardando Master",
    shortLabel: "Master",
    icon: "Account",
  },
  {
    path: "/modulo/cadastros/produtos/cadastro",
    label: "Fila de cadastro",
    shortLabel: "Cadastro",
    icon: "Check",
  },
  {
    path: "/modulo/cadastros/fornecedores",
    label: "Em breve",
    shortLabel: "Em breve",
    icon: "Business",
    disabled: true,
  },
];

/** @deprecated Use NAV_ITEMS — mantido para compatibilidade. */
export const NAV_GROUPS = [{ id: "menu", label: "Menu", items: NAV_ITEMS }];

export const getNavItemByPath = (pathname) => {
  const normalized = pathname.replace(/\/$/, "") || "/";
  return (
    [...NAV_ITEMS]
      .sort((a, b) => b.path.length - a.path.length)
      .find(
        (item) =>
          normalized === item.path || normalized.startsWith(`${item.path}/`)
      ) || null
  );
};
